<template>
  <div id="app">
    <ModalIdle v-if="isIdle" />
    <BloqueoPti ref="block" @cambiarBloqueo="cambiarBloqueo"/>
    <div v-if="!bloquear">
      <router-view />
    </div>
  </div>
</template>

<script>
import ModalIdle from "./components/ModalIdle";
import BloqueoPti from "@/components/BloqueoPti/BloqueoPti";

export default {
  name: "app",
  components: {
    ModalIdle,
    BloqueoPti
  },
  data: () => ({
    bloquear:true
  }),
  methods: {
    cambiarBloqueo(bloquear) {
      this.bloquear=bloquear;
    }
  },
  computed: {
    isIdle() {
      return this.$store.state.idleVue.isIdle;
    }
  },
  watch: {
    '$route': {
      handler: function () {
        this.bloquear = true;
        this.$refs.block.verificarBloqueo();
      },
      deep: true,
    }
  }
};
</script>

<style>
#app {
  font-family: Gilroy;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

@font-face {
  font-family: "Gilroy";
  src: url(./fonts/Gilroy/Gilroy-Regular.ttf);
  font-weight: normal;
}

@font-face {
  font-family: "Gilroy";
  src: url(./fonts/Gilroy/Gilroy-Medium.ttf);
  font-weight: 500;
}

@font-face {
  font-family: "Gilroy";
  src: url(./fonts/Gilroy/Gilroy-SemiBold.ttf);
  font-weight: 600;
}

@font-face {
  font-family: "Gilroy";
  src: url(./fonts/Gilroy/Gilroy-MediumItalic.ttf);
  font-weight: normal;
  font-style: italic;
}

@font-face {
  font-family: "Gilroy";
  src: url(./fonts/Gilroy/Gilroy-Bold.ttf);
  font-weight: bold;
}

@font-face {
  font-family: "Gilroy";
  src: url(./fonts/Gilroy/Gilroy-BoldItalic.ttf);
  font-weight: bold;
  font-style: italic;
}

@font-face {
  font-family: "Silene";
  src: url(./fonts/Silene-Roman.otf);
  font-weight: normal;
  font-style: normal;
}
</style>
